module.exports = __webpack_public_path__ + "static/media/star.62eca182.svg";